import React, { useState, useEffect } from "react";

import { GetMovieByIdResponse } from "../../../../../common/api/catalogue-api/movie/GetMovieByIdResponse";
import { MovieVersionDocumentResponse } from "../../../../../common/api/catalogue-api/movie/MovieDocumentResponse";
import { useCatalogueMovieApi } from "../../../../../common/api/catalogue-api/movie/useCatalogueMovieApi";
import { BuzzVersionsList } from "../../../common/buzz-version/BuzzVersionsList";
import { MediaBuzzVersion, mapToMediaBuzzVersion } from "../../../common/buzz-version/MediaBuzzVersion";

interface MovieVersionInfoAsideContentProps {
    movieId: string;
    versionIds: string[];
}

export const OnPremMovieVersionInfo: React.FC<MovieVersionInfoAsideContentProps> = (
    props: MovieVersionInfoAsideContentProps
) => {
    const { movieId, versionIds } = props;

    const { getMovieById } = useCatalogueMovieApi();

    const [movieBuzzVersions, setMovieBuzzVersions] = useState<MediaBuzzVersion[]>([]);

    useEffect(() => {
        getMovieById(movieId).then((response: GetMovieByIdResponse) => {
            const versions = response.versions
                .filter((version: MovieVersionDocumentResponse) => versionIds.includes(version.id))
                .map(mapToMediaBuzzVersion);

            setMovieBuzzVersions(versions);
        });
    }, [movieId]);

    return <BuzzVersionsList versions={movieBuzzVersions} />;
};
